import { CacheBuster } from "./src/containers/CacheBuster"
import React from 'react'

export const wrapRootElement = ({ element }) => {
  return <CacheBuster>{element}</CacheBuster>
}

export const onServiceWorkerUpdateReady = () => window.location.reload()
